import { ChangesState } from 'src/components/pipelines/redux/reducers/changes';
import { LoadingStatus } from 'src/constants/loading-status';

export const canDisplayDeploymentSummaryAiAssistant = (
  workspaceDevAgentsEnabled: boolean,
  deploymentSummaryAiAssistantEnabled: boolean,
  deploymentChanges: ChangesState
): boolean => {
  return (
    workspaceDevAgentsEnabled &&
    deploymentSummaryAiAssistantEnabled &&
    deploymentChanges?.fetchedStatus === LoadingStatus.Success &&
    deploymentChanges?.fetchedPullRequests === LoadingStatus.Success
  );
};
